var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRopeBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.496,
    height: 18.938,
    viewBox: "0 0 111.496 18.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(0 5.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M534.5,951.238s2.159,2.453,3.667,2.586,2.154-.7,2.923-.463-2.113-2.6-3.627-2.617A9.733,9.733,0,0,0,534.5,951.238Z",
    transform: "translate(-534.497 -950.744)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(6.243 4.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M557.178,947.688a15.273,15.273,0,0,0,1.25,1.264,5.12,5.12,0,0,0,2.367,1.392c1.5.171,2.163-.646,2.923-.384.378.13-.123-.535-.917-1.241a5.359,5.359,0,0,0-2.639-1.47A9.566,9.566,0,0,0,557.178,947.688Z",
    transform: "translate(-557.178 -947.245)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(12.531 4.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M580.024,944.742a16.1,16.1,0,0,0,1.211,1.3,5.2,5.2,0,0,0,2.311,1.477c1.484.23,2.18-.557,2.924-.259.37.148-.1-.54-.858-1.283a5.3,5.3,0,0,0-2.58-1.576A9.386,9.386,0,0,0,580.024,944.742Z",
    transform: "translate(-580.024 -944.386)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(18.873 3.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M603.065,942.739a17.407,17.407,0,0,0,1.15,1.358,5.281,5.281,0,0,0,2.227,1.6c1.462.312,2.2-.43,2.921-.084.357.172-.06-.545-.775-1.336a5.238,5.238,0,0,0-2.489-1.721A9.227,9.227,0,0,0,603.065,942.739Z",
    transform: "translate(-603.065 -942.496)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(21.861 3.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M626.3,942.03s.111.172.3.436.454.619.76.994a5.36,5.36,0,0,0,2.1,1.751,3.84,3.84,0,0,0,1.727.079,1.7,1.7,0,0,1,1.176.066c.339.2-.012-.55-.659-1.4a5.16,5.16,0,0,0-2.354-1.908,8.339,8.339,0,0,0-2.092-.129A7.6,7.6,0,0,0,626.3,942.03Z",
    transform: "translate(-626.296 -941.91)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(27.435 3.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M649.651,942.964s.1.181.263.46.4.653.674,1.055a5.445,5.445,0,0,0,1.929,1.936,3.864,3.864,0,0,0,1.7.247,1.657,1.657,0,0,1,1.156.186c.313.237.048-.549-.508-1.456a5.079,5.079,0,0,0-2.159-2.131,8.227,8.227,0,0,0-2.083-.321A7.867,7.867,0,0,0,649.651,942.964Z",
    transform: "translate(-649.651 -942.936)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(33.007 4.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M672.954,945.964s.078.19.214.486.33.691.557,1.122a5.553,5.553,0,0,0,1.691,2.141,3.879,3.879,0,0,0,1.65.447,1.627,1.627,0,0,1,1.118.328c.278.274.12-.537-.317-1.509a5.008,5.008,0,0,0-1.892-2.376,8.092,8.092,0,0,0-2.045-.558A7.611,7.611,0,0,0,672.954,945.964Z",
    transform: "translate(-672.954 -945.964)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(38.502 5.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M695.871,951.626s.054.2.151.51.24.727.408,1.185a5.644,5.644,0,0,0,1.384,2.348,3.9,3.9,0,0,0,1.564.671,1.6,1.6,0,0,1,1.055.483c.234.311.2-.514-.1-1.539a4.952,4.952,0,0,0-1.545-2.619,7.955,7.955,0,0,0-1.961-.83,6.817,6.817,0,0,0-.693-.162Z",
    transform: "translate(-695.871 -951.626)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(43.788 7.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M717.882,960.408s.025.205.076.527.132.755.233,1.229a5.43,5.43,0,0,0,1.046,2.525c1.072,1.042,2.1.812,2.558,1.482.228.337.219-.5.02-1.546a5.307,5.307,0,0,0-1.2-2.779,8.134,8.134,0,0,0-1.81-1.093A7.963,7.963,0,0,0,717.882,960.408Z",
    transform: "translate(-717.882 -960.408)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(48.648 10.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M738.273,971.684a13.22,13.22,0,0,0,.182,1.762A4.664,4.664,0,0,0,739.536,976a3.705,3.705,0,0,0,1.647.828,2.235,2.235,0,0,1,1.17.506c.3.308.123-.526-.189-1.546a6.327,6.327,0,0,0-1.331-2.667,9.656,9.656,0,0,0-1.7-1.056C738.633,971.817,738.273,971.684,738.273,971.684Z",
    transform: "translate(-738.273 -971.684)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(53.251 12.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M757.9,981.8s.026.2.091.513a9.465,9.465,0,0,0,.336,1.188,4.167,4.167,0,0,0,1.645,2.28,3.408,3.408,0,0,0,1.031.325,4.008,4.008,0,0,0,.866.035c.261-.008.495-.028.713-.025a1.487,1.487,0,0,1,.614.142c.4.189-.076-.536-.7-1.4a7.8,7.8,0,0,0-1.965-2.186,12.42,12.42,0,0,0-1.777-.646c-.25-.077-.464-.129-.615-.165Z",
    transform: "translate(-757.896 -981.801)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(57.98 13.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M778.158,986.072a6.89,6.89,0,0,0,.972,1.441,5.465,5.465,0,0,0,.526.524,3.953,3.953,0,0,0,.614.455,3.309,3.309,0,0,0,.668.318,2.446,2.446,0,0,0,.67.118,3.742,3.742,0,0,0,.6-.057,2.44,2.44,0,0,0,.519-.138c.159-.058.306-.122.443-.187s.265-.151.385-.224l.646-.412a1.684,1.684,0,0,1,.629-.232c.228-.039.139-.144-.138-.275s-.746-.322-1.234-.513l-1.494-.652c-.233-.093-.457-.187-.66-.253a2.217,2.217,0,0,0-.548-.1c-.642.005-1.278.051-1.769.1S778.158,986.072,778.158,986.072Z",
    transform: "translate(-778.158 -985.881)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(62.492 10.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M796.906,974.291s.163.1.445.239a5.316,5.316,0,0,0,1.149.4,4.144,4.144,0,0,0,.737.108,3.876,3.876,0,0,0,.772-.015,3.745,3.745,0,0,0,.732-.171,2.348,2.348,0,0,0,.6-.343,2.716,2.716,0,0,0,.443-.44,3.044,3.044,0,0,0,.322-.45,4.265,4.265,0,0,0,.37-.868c.076-.276.151-.516.221-.742a1.6,1.6,0,0,1,.322-.606c.148-.188.009-.206-.285-.113s-.766.269-1.273.441l-.783.252c-.266.078-.532.15-.767.226a3.832,3.832,0,0,0-1.144.466c-.235.2-.484.383-.69.581-.226.176-.411.372-.592.515s-.314.29-.421.375S796.906,974.291,796.906,974.291Z",
    transform: "translate(-796.906 -971.235)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(65.449 4.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M808.3,950.959a4.419,4.419,0,0,0,.482-.112,4.168,4.168,0,0,0,1.107-.48c.1-.062.208-.13.313-.2s.193-.155.287-.242a3.493,3.493,0,0,0,.525-.587,3.605,3.605,0,0,0,.36-.693,2.383,2.383,0,0,0,.119-.727,2.459,2.459,0,0,0-.082-.661,4.812,4.812,0,0,0-.17-.567,5.816,5.816,0,0,0-.514-.856,4.316,4.316,0,0,1-.862-1.231c-.079-.231-.167-.124-.25.179-.043.15-.086.347-.133.569s-.12.486-.187.745a15.319,15.319,0,0,1-.492,1.52,4.3,4.3,0,0,0-.366,1.112c0,.07,0,.138,0,.206s-.014.137-.016.2c-.014.135,0,.264-.014.392-.026.256-.018.5-.047.707-.009.105-.007.2-.016.292s-.021.165-.027.229C808.3,950.882,808.3,950.959,808.3,950.959Z",
    transform: "translate(-808.301 -944.476)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(61 1.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M794.172,937.725a4.428,4.428,0,0,0,.179-.474,5.347,5.347,0,0,0,.189-1.19,4.377,4.377,0,0,0-.047-.739,3.47,3.47,0,0,0-.18-.756,3.744,3.744,0,0,0-.331-.68,2.079,2.079,0,0,0-.467-.512,3.482,3.482,0,0,0-1.918-.727c-.271-.038-.517-.041-.74-.072a1.562,1.562,0,0,1-.616-.216c-.2-.113-.194.024-.068.3s.362.72.623,1.178l.781,1.429a5.335,5.335,0,0,0,.364.6,1.671,1.671,0,0,0,.35.422l.185.138q.086.076.173.145c.116.093.234.176.35.254s.209.171.312.245a3.045,3.045,0,0,1,.285.21c.165.139.322.24.424.319S794.172,937.725,794.172,937.725Z",
    transform: "translate(-790.084 -932.319)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(54.793 1.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M771.234,935.579s-.064-.182-.2-.467c-.066-.142-.151-.31-.254-.494a6.047,6.047,0,0,0-.371-.555,5.855,5.855,0,0,0-.485-.573,5.022,5.022,0,0,0-.585-.489c-.1-.074-.211-.144-.321-.208a3.117,3.117,0,0,0-.332-.15,2.485,2.485,0,0,0-.67-.162,3.77,3.77,0,0,0-1.144.14,4.931,4.931,0,0,0-.812.347,2.633,2.633,0,0,1-1.246.486c-.221,0-.149.116.1.29s.668.4,1.144.662c.237.129.483.254.729.38s.494.258.727.364.45.221.646.29a2.353,2.353,0,0,0,.531.134c.159.014.316.02.469.019s.307.016.454.013l.808-.006c.239-.015.44-.007.582-.011S771.234,935.579,771.234,935.579Z",
    transform: "translate(-764.685 -932.482)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(49.881 3.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M751.064,943.2s-.157-.125-.424-.3a8.574,8.574,0,0,0-1.087-.578,4.151,4.151,0,0,0-2.785-.338,3.656,3.656,0,0,0-1.528,1.086c-.338.37-.576.69-.982.792s.4.368,1.452.557a6.9,6.9,0,0,0,2.959.089,9.463,9.463,0,0,0,.911-.435c.285-.14.539-.3.759-.425s.4-.241.526-.326Z",
    transform: "translate(-744.152 -941.857)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(45.802 7.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M733.709,956.838s-.19-.067-.5-.156a10.542,10.542,0,0,0-1.211-.274,4.766,4.766,0,0,0-2.76.171c-1.35.738-1.408,1.791-2.178,2.014-.384.108.411.369,1.466.48a5.566,5.566,0,0,0,2.993-.307,9.816,9.816,0,0,0,1.56-1.263c.195-.194.353-.358.462-.476Z",
    transform: "translate(-726.962 -956.292)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(41.726 10.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M716.688,972.161a17.34,17.34,0,0,0-1.743-.362,5.429,5.429,0,0,0-2.73.091c-1.333.622-1.48,1.637-2.257,1.768-.386.053.363.426,1.4.638a4.988,4.988,0,0,0,3.037-.115,8.286,8.286,0,0,0,1.65-1.3A7.943,7.943,0,0,0,716.688,972.161Z",
    transform: "translate(-709.854 -971.674)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(37.282 13.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M698.184,985.884s-.193-.075-.5-.182-.731-.245-1.2-.384a13.3,13.3,0,0,0-1.432-.34,3.291,3.291,0,0,0-1.251-.01,3.866,3.866,0,0,0-.859.344,5.6,5.6,0,0,0-.6.415c-.356.256-.636.5-1.018.454-.188-.021-.126.1.1.291a4.136,4.136,0,0,0,.455.322,6.761,6.761,0,0,0,.642.338,7.968,7.968,0,0,0,.773.31,6.445,6.445,0,0,0,.818.2,2.846,2.846,0,0,0,1.439-.041,7.534,7.534,0,0,0,1.886-1.071,6.7,6.7,0,0,0,.554-.461Z",
    transform: "translate(-691.209 -984.912)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(32.523 15.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M677.834,994.782l-.449-.3-1.067-.677c-.411-.252-.852-.507-1.273-.725a4.394,4.394,0,0,0-.609-.258,2.073,2.073,0,0,0-.543-.139,2.723,2.723,0,0,0-.465,0,2.577,2.577,0,0,0-.407.031c-.253.034-.471.124-.678.169-.409.1-.75.232-1.072.032-.159-.093-.151.043-.022.306a3.9,3.9,0,0,0,.288.476,5.588,5.588,0,0,0,.459.555,7.021,7.021,0,0,0,.6.576,5.166,5.166,0,0,0,.7.479,3.406,3.406,0,0,0,.737.332,2.241,2.241,0,0,0,.684.1,6.742,6.742,0,0,0,2.188-.507,5.2,5.2,0,0,0,.677-.311Z",
    transform: "translate(-671.151 -992.676)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(27.905 14.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M656.86,993.089l-.3-.45-.324-.471-.387-.58c-.273-.4-.565-.808-.849-1.189a4.518,4.518,0,0,0-.432-.491,2.355,2.355,0,0,0-.432-.357,2.774,2.774,0,0,0-.421-.2,4.028,4.028,0,0,0-.379-.143,5.884,5.884,0,0,0-.678-.136,4.239,4.239,0,0,1-.557-.13.922.922,0,0,1-.227-.111.776.776,0,0,1-.171-.192c-.1-.153-.151-.028-.156.264a3.756,3.756,0,0,0,.04.553,5.82,5.82,0,0,0,.166.7,6.754,6.754,0,0,0,.292.784,5.88,5.88,0,0,0,.429.733,2.72,2.72,0,0,0,1.1,1,6.52,6.52,0,0,0,2.236.465,4.6,4.6,0,0,0,.763-.01Z",
    transform: "translate(-651.544 -988.568)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(23.943 10.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M637.876,981.646l-.073-.541-.078-.568-.076-.7c-.054-.468-.112-.973-.166-1.443a4.685,4.685,0,0,0-.119-.624,1.863,1.863,0,0,0-.163-.513c-.072-.144-.16-.258-.231-.373a2.112,2.112,0,0,0-.22-.306,2.48,2.48,0,0,0-.24-.24c-.081-.072-.142-.151-.214-.218a3.959,3.959,0,0,1-.369-.395.7.7,0,0,1-.113-.461c.018-.17-.1-.106-.285.115a3.412,3.412,0,0,0-.3.454c-.053.094-.11.2-.161.31s-.09.223-.132.345a4.427,4.427,0,0,0-.261,1.667,3.67,3.67,0,0,0,.119.826,2.339,2.339,0,0,0,.314.642,5.877,5.877,0,0,0,1.791,1.559c.141.082.268.161.388.217l.314.136Z",
    transform: "translate(-634.664 -975.17)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(21.639 6.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M625.928,963.134l.264-.48c.156-.289.416-.7.667-1.1.121-.2.278-.41.414-.611s.262-.394.4-.584a5.087,5.087,0,0,0,.339-.536,2.261,2.261,0,0,0,.215-.483,3.422,3.422,0,0,0,.119-.8,4.41,4.41,0,0,0-.026-.652,2.666,2.666,0,0,1,0-.547.654.654,0,0,1,.213-.433c.128-.119-.006-.15-.29-.1a3.5,3.5,0,0,0-.53.143,4.862,4.862,0,0,0-.65.3,4.717,4.717,0,0,0-1.319,1.059,4.148,4.148,0,0,0-.457.691,2.1,2.1,0,0,0-.2.693c-.011.11-.021.22-.026.33s.005.22.01.329a6.421,6.421,0,0,0,.059.643,6.074,6.074,0,0,0,.3,1.119,4.924,4.924,0,0,0,.339.753C625.866,963.039,625.928,963.134,625.928,963.134Z",
    transform: "translate(-625.058 -956.786)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(21.998 3.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M626.852,943.295l.515-.183c.322-.109.765-.247,1.218-.39l1.4-.407a4.844,4.844,0,0,0,.6-.212,1.9,1.9,0,0,0,.473-.245c.122-.1.235-.189.337-.277a2.074,2.074,0,0,0,.254-.275,3.3,3.3,0,0,0,.38-.514c.231-.3.418-.589.768-.591.167-.005.088-.116-.155-.265a3.565,3.565,0,0,0-1.179-.427,4.546,4.546,0,0,0-1.7-.01,2.711,2.711,0,0,0-1.378.67,5.617,5.617,0,0,0-.778,1.026,7.2,7.2,0,0,0-.473,1.026,8.023,8.023,0,0,0-.227.77Z",
    transform: "translate(-626.852 -939.425)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(25.732 0.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M642.633,928.787s.2.07.516.195l1.177.505c.444.207.9.432,1.313.615a3.678,3.678,0,0,0,1.117.368,2.8,2.8,0,0,0,.446,0,2.35,2.35,0,0,0,.391-.033c.121-.019.234-.052.343-.079s.214-.05.314-.078a1.271,1.271,0,0,1,1.05-.014c.3.184.013-.546-.683-1.36a6.325,6.325,0,0,0-.593-.572c-.11-.093-.224-.185-.342-.269s-.239-.153-.363-.222a3.453,3.453,0,0,0-.753-.326,2.342,2.342,0,0,0-.707-.082,3.8,3.8,0,0,0-.641.1,5.611,5.611,0,0,0-.614.16,6.829,6.829,0,0,0-1.04.459c-.29.169-.525.322-.686.432S642.633,928.787,642.633,928.787Z",
    transform: "translate(-642.633 -927.435)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(31.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M667.928,926.26l.289.467.677,1.071c.258.418.537.83.814,1.218a4.5,4.5,0,0,0,.424.5,2,2,0,0,0,.438.367,3.915,3.915,0,0,0,1.539.5,1.488,1.488,0,0,1,1.036.409c.232.293.192-.514-.151-1.522a4.4,4.4,0,0,0-1.811-2.49,6.809,6.809,0,0,0-2.2-.528A8.486,8.486,0,0,0,667.928,926.26Z",
    transform: "translate(-667.928 -926.244)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(37.606 1.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M691.974,932.519l.1.531c.062.327.158.756.263,1.233a5.874,5.874,0,0,0,1,2.524c1.011,1.05,2.033.872,2.438,1.561.2.347.258-.485.117-1.537A4.992,4.992,0,0,0,694.783,934a7.545,7.545,0,0,0-1.85-1.134A8.375,8.375,0,0,0,691.974,932.519Z",
    transform: "translate(-691.974 -932.519)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(42.537 4.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M712.556,944.525a15.762,15.762,0,0,0,.065,1.777,4.9,4.9,0,0,0,.831,2.632c1.049,1.149,2.126.948,2.589,1.634.244.342.206-.5.026-1.554a5.952,5.952,0,0,0-1.032-2.814,9.85,9.85,0,0,0-2.479-1.675Z",
    transform: "translate(-712.552 -944.525)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(46.994 6.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M731.425,956.832s0,.2.023.521a9.689,9.689,0,0,0,.161,1.228,4.284,4.284,0,0,0,1.237,2.516,3.773,3.773,0,0,0,.94.491,3.514,3.514,0,0,0,.821.194,2.221,2.221,0,0,1,1.229.384c.332.267.063-.532-.36-1.523-.213-.492-.471-1-.724-1.477a3.2,3.2,0,0,0-.82-1.039c-.286-.2-.586-.373-.871-.536s-.564-.293-.805-.406-.45-.2-.6-.262Z",
    transform: "translate(-731.425 -956.832)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(51.603 9.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M751.054,965.315a9.7,9.7,0,0,0,.615,1.646,4.312,4.312,0,0,0,1.848,2.094,3.648,3.648,0,0,0,1.851.228,2.208,2.208,0,0,1,1.264.075c.377.2-.053-.549-.7-1.385a6.7,6.7,0,0,0-2.135-2.064c-.167-.06-.336-.1-.5-.154s-.327-.1-.486-.136c-.317-.082-.623-.119-.879-.175A7.959,7.959,0,0,0,751.054,965.315Z",
    transform: "translate(-751.054 -965.315)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(56.624 9.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M772.328,968.359s.094.179.262.455a10.432,10.432,0,0,0,.714,1.008,4.543,4.543,0,0,0,2.213,1.69c1.553.3,2.287-.5,3.058-.223.39.132-.124-.526-.894-1.269a6.124,6.124,0,0,0-2.485-1.652,7.181,7.181,0,0,0-1.049-.088c-.336,0-.647-.01-.917.006C772.691,968.318,772.328,968.359,772.328,968.359Z",
    transform: "translate(-772.328 -968.275)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(61.845 9.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M794.349,966.809a12.207,12.207,0,0,0,1.182,1.316,4.778,4.778,0,0,0,2.376,1.412c1.543.152,2.194-.7,2.973-.474.392.112-.155-.527-.976-1.2a5.758,5.758,0,0,0-2.646-1.419,9.611,9.611,0,0,0-2,.165A8.824,8.824,0,0,0,794.349,966.809Z",
    transform: "translate(-794.349 -966.442)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(67.14 8.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M816.625,963.226a13.229,13.229,0,0,0,1.27,1.237,4.986,4.986,0,0,0,2.42,1.313c1.518.108,2.145-.741,2.917-.517s-2.163-2.556-3.67-2.551A9.976,9.976,0,0,0,816.625,963.226Z",
    transform: "translate(-816.625 -962.708)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(72.509 7.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M839.16,959.321a15.59,15.59,0,0,0,1.274,1.243,5.223,5.223,0,0,0,2.377,1.364c1.485.163,2.141-.645,2.89-.374.37.144-.111-.546-.9-1.25a5.225,5.225,0,0,0-2.651-1.467A9.507,9.507,0,0,0,839.16,959.321Z",
    transform: "translate(-839.16 -958.834)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(78.012 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M862.173,956.493a17.632,17.632,0,0,0,1.193,1.322,5.521,5.521,0,0,0,2.233,1.571,3.855,3.855,0,0,0,1.7-.04,1.609,1.609,0,0,1,1.156,0c.34.184-.031-.546-.722-1.361a4.973,4.973,0,0,0-2.492-1.742,6.294,6.294,0,0,0-1.131-.04,8.791,8.791,0,0,0-1.94.288Z",
    transform: "translate(-862.173 -956.197)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(83.695 6.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M885.791,956.052s.434.694,1.006,1.481a12.035,12.035,0,0,0,.936,1.134,2.931,2.931,0,0,0,1,.76,3.637,3.637,0,0,0,1.65.266,1.6,1.6,0,0,1,1.125.225c.3.248.079-.546-.441-1.471a6.8,6.8,0,0,0-.98-1.345,2.847,2.847,0,0,0-1.169-.826,8.433,8.433,0,0,0-1.13-.232c-.366-.037-.711-.049-1.007-.051a6.254,6.254,0,0,0-.718.027Z",
    transform: "translate(-885.791 -955.993)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(86.835 7.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M909.585,959.188s.283.78.7,1.648a5.45,5.45,0,0,0,1.581,2.228c1.268.775,2.217.329,2.794.887s-.686-3.279-2.082-3.965a8.151,8.151,0,0,0-2.01-.663A9.158,9.158,0,0,0,909.585,959.188Z",
    transform: "translate(-909.585 -959.188)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(93.019 9.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M932.052,965.762a14.9,14.9,0,0,0,.541,1.691,4.911,4.911,0,0,0,1.519,2.3c1.316.816,2.29.336,2.911.875.319.266.072-.538-.378-1.5a5.843,5.843,0,0,0-1.758-2.433A10.042,10.042,0,0,0,932.052,965.762Z",
    transform: "translate(-932.052 -965.762)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(98.95 10.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M953.6,972.531a10.884,10.884,0,0,0,.63,1.648,7.107,7.107,0,0,0,.772,1.275,2.83,2.83,0,0,0,1.021.863,3.283,3.283,0,0,0,1.018.271,4.134,4.134,0,0,0,.844,0,2.346,2.346,0,0,1,1.3.093c.195.093.182-.044.034-.306a10.166,10.166,0,0,0-.741-1.088,6.868,6.868,0,0,0-2.083-2.108,10.728,10.728,0,0,0-1.885-.516C953.972,972.568,953.6,972.531,953.6,972.531Z",
    transform: "translate(-953.6 -972.531)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(104.793 11.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M974.828,975.776s.09.176.257.446a7.544,7.544,0,0,0,.725,1,3.929,3.929,0,0,0,2.4,1.506,3.3,3.3,0,0,0,1.1-.109,3.837,3.837,0,0,0,.821-.321,2.693,2.693,0,0,1,1.27-.443c.453.017-.3-.467-1.219-.986-.468-.277-.97-.552-1.433-.8a3.378,3.378,0,0,0-1.216-.428,14.213,14.213,0,0,0-1.84.045l-.62.059Z",
    transform: "translate(-974.828 -975.625)",
    fill: "#151b47"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRopeBlue);
export default __webpack_public_path__ + "static/media/rope_blue.b03274c123060f4bc10ecca75d2e51b4.svg";
export { ForwardRef as ReactComponent };